import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';

import { NgSelectModule } from '@ng-select/ng-select';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';

import { NgxEchartsModule } from 'ngx-echarts';

// ANCHOR NGPRIME
import { ButtonModule } from 'primeng/button';
import { CarouselModule } from 'primeng/carousel';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TableModule } from 'primeng/table';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { MessageModule } from 'primeng/message';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    CarouselModule,
    DropdownModule,
    InputNumberModule,
    InputSwitchModule,
    TableModule,
    ToggleSwitchModule,
    NgbNavModule,
    NgSelectModule,
    NgbCollapseModule,
    NgxEchartsModule.forRoot({
      /**
       * This will import all modules from echarts.
       * If you only need custom modules,
       * please refer to [Custom Build] section.
       */
      echarts: () => import('echarts'), // or import('./path-to-my-custom-echarts')
    }),
    MessageModule,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    CarouselModule,
    DropdownModule,
    InputNumberModule,
    InputSwitchModule,
    TableModule,
    ToggleSwitchModule,
    NgbNavModule,
    NgSelectModule,
    NgbCollapseModule,
    MessageModule,
  ]
})
export class SharedModule { }
